module.exports = __webpack_public_path__ + "img/ssyx_02.de0a5d8e.jpg";